import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import expandIcon from "../../assests/page/chevron-right.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import transferVertical from "../../assests/page/transfer-vertical.svg";
import graphUp from "../../assests/page/graph-up.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import indiaFlag from "../../assests/page/Flag_of_India 1.svg";
import graphImg from "../../assests/page/convert-funds-graph.svg";
import unitedStatesFlag from "../../assests/page/Flag-United-States-of-America 1.svg";
import { useEffect, useState } from "react";
import {
  currenciesToSymbol,
  errorToast,
  rateBucketName,
  successToast,
} from "../../utils/constants";
import AddFunds from "./addFunds";
import { Cash, contractAddress } from "@verified-network/verified-sdk";
import CASHABI from "../../utils/abis/Cash.json";
import Avatar from "react-avatar";
import { ethers } from "ethers";
import { ChainConfig, chainDetails } from "../../utils/config";
import ERC20ABI from "../../utils/abis/ERC20.json";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import { extractNumberWithCommas, getObject } from "../../utils/helpers/utils";
import { useTranslation } from "react-i18next";

const ConvertFunds = (props) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState("");
  const [amountFmt, setAmountFmt] = useState("");
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [allCurrenciesLoading, setAllCurrenciesLoading] = useState(false);
  const [allCurrencies, setAllCurrencies] = useState([]);
  const [currencyClicked, setCurrencyClicked] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState({});
  const [selectedCurrencyTo, setSelectedCurrencyTo] = useState({});
  const [newSearchContent, setNewSearchContent] = useState(null);
  const [showGraph, setShowGraph] = useState(false);
  const [incorrectAmount, setIncorrectAmount] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0.0);
  const [exchangeRate, setExchangeRate] = useState(0.0);

  const { chainId, provider, web3 } = useNetworkStore();

  const { userAddress } = useUserStore();

  useEffect(() => {
    (async () => {
      const getAllCashCurrencies = async () => {
        setAllCurrenciesLoading(true);
        const cashCurrencies = contractAddress[chainId]?.CASH;
        const validCashCurrencies = Object.keys(cashCurrencies).map((key) => {
          if (cashCurrencies[key]?.length > 0) {
            return {
              address: cashCurrencies[key],
              currencySymbol: key,
              officialCurrencySymbol: currenciesToSymbol[
                key
                  ?.toString()
                  .substring(2, key?.toString()?.length)
                  .toUpperCase()
              ]
                ? currenciesToSymbol[
                    key
                      ?.toString()
                      .substring(2, key?.toString()?.length)
                      .toUpperCase()
                  ]
                : key?.toUpperCase()?.slice(2, key?.length),
              currencyName: key,
              symbolFmt: key
                ?.toString()
                .substring(2, key?.toString()?.length)
                .toUpperCase(),
            };
          } else {
            return null;
          }
        });

        setAllCurrencies(validCashCurrencies.filter((curr) => curr !== null));
        setAllCurrenciesLoading(false);
      };

      await getAllCashCurrencies();
    })();
  }, [chainId]);

  useEffect(() => {
    const getBalance = async () => {
      const securityBalanceRaw = await new web3.eth.Contract(
        ERC20ABI,
        selectedCurrency?.address,
      ).methods
        .balanceOf(userAddress)
        .call();
      setWalletBalance(Number(ethers.utils.formatEther(securityBalanceRaw)));
    };

    if (userAddress && selectedCurrency?.address && web3) {
      getBalance();
    }
  }, [web3, userAddress, selectedCurrency]);

  useEffect(() => {
    (async () => {
      const getExchangeRate = async () => {
        const AllRates = await getObject(
          `${chainDetails[chainId]?.name?.toLowerCase()}-rates`,
          rateBucketName,
        );

        if (AllRates) {
          const allRatesFmt = JSON.parse(AllRates);

          setExchangeRate(
            Number(
              allRatesFmt[
                `${selectedCurrency?.symbolFmt}-${selectedCurrencyTo?.symbolFmt}`
              ],
            ),
          );
        }
      };

      await getExchangeRate();
    })();
  }, [chainId, selectedCurrency, selectedCurrencyTo]);

  useEffect(() => {
    (async () => {
      if (Number(amount) > Number(walletBalance)) {
        setIncorrectAmount(true);
      } else {
        setIncorrectAmount(false);
      }
    })();
  }, [walletBalance, amount]);

  const handleAddFundsButtonDisplay = () => {
    const button = document.getElementById("add-funds-popup-button");
    if (
      button &&
      document.getElementById("add-funds-popup-input").value.length > 0 &&
      Number(document.getElementById("add-funds-popup-input").value) > 0
    ) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  const handleChooseCurrencyButtonDisplay = () => {
    const button = document.getElementById("convert-currency-popup-button");
    if (button && selectedCurrency.isClicked) {
      button.className = "startup-button-active";
    } else if (button && selectedCurrencyTo.isClicked) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  return (
    <div className="add-funds-popup">
      {!showAllCurrencies && (
        <div
          style={{ overflowX: "hidden", overflowY: "auto" }}
          className="add-funds-content"
        >
          <div className="add-funds-content-header">
            <div className="add-funds-content-header-text-container">
              {showGraph && (
                <img
                  className="profile-popup-icon"
                  onClick={() => {
                    setShowGraph(false);
                  }}
                  alt="Close Icon"
                  src={backIcon}
                />
              )}
              {!showGraph && (
                <p className="add-funds-content-header-text">
                  {t("header.convertCurrency")}
                </p>
              )}
              {showGraph && (
                <p className="add-funds-content-header-text">Graph View</p>
              )}
            </div>
            <img
              onClick={() => {
                props.setShowPopup(false);
                props.setPopupContent(null);
                setNewSearchContent(null);
                props.setPopupContentPosition("center");
                if (props.setFavouriteClicked) {
                  props.setFavouriteClicked(false);
                }
              }}
              className="add-funds-popup-close-icon"
              alt="Close Icon"
              src={popupCloseIcon}
            />
          </div>
          {!showGraph && (
            <div className="add-funds-content-footer">
              <div className="convert-funds-popup-header-container">
                <div className="convert-funds-popup-header">
                  <p className="add-funds-content-footer-balance-first">
                    {t("convertFunds.walletBalance")}:
                  </p>
                  <p className="add-funds-content-footer-balance-second">
                    {selectedCurrency.officialCurrencySymbol}{" "}
                    {walletBalance?.toFixed(4)}
                  </p>
                </div>
                {incorrectAmount && (
                  <p
                    onClick={() => {
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(
                        <AddFunds
                          setPopupContent={props.setPopupContent}
                          setShowPopup={props.setShowPopup}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds"
                        />,
                      );
                    }}
                    className="convert-funds-popup-header-text"
                  >
                    {" "}
                    +{t("header.addFunds")}
                  </p>
                )}
              </div>
              <div
                style={{ marginBottom: "12px" }}
                className="asset-info-popup-second-trading-body-line"
              ></div>
              <div className="convert-funds-popup-input-group">
                <div className="convert-funds-popup-first-input-group">
                  <p className="convert-funds-popup-first-input-text">
                    {" "}
                    {t("convertFunds.from")}
                  </p>
                  <div className="convert-funds-popup-first-input-main">
                    <div className="convert-funds-popup-first-input-container">
                      <div
                        style={{ gap: "4px" }}
                        className="a-f-content-footer-input-group"
                      >
                        <p className="a-f-content-footer-input-text">
                          {selectedCurrency.officialCurrencySymbol}
                        </p>
                        <input
                          onInput={(e) => {
                            const ext = extractNumberWithCommas(e.target.value);
                            setAmount(ext.number);
                            setAmountFmt(ext?.fmtNumber);
                            if (Number(ext.number) > Number(walletBalance)) {
                              setIncorrectAmount(true);
                            } else {
                              setIncorrectAmount(false);
                            }
                          }}
                          value={amountFmt}
                          className="convert-funds-popup-first-input"
                          type="text"
                          placeholder="00.00"
                        />
                      </div>
                      <div
                        onClick={() => {
                          setCurrencyClicked("from");
                          setShowAllCurrencies(true);
                        }}
                        className="convert-funds-popup-first-input-content"
                      >
                        {selectedCurrency?.flag && (
                          <div className="convert-funds-popup-first-input-content-icon">
                            <img
                              src={selectedCurrency.flag}
                              alt="Country Flag"
                            />
                          </div>
                        )}

                        <div className="convert-funds-popup-first-input-content-text-container">
                          <p className="convert-funds-popup-first-input-content-text">
                            {selectedCurrency.currencySymbol}
                          </p>
                          <img src={expandIcon} alt="Expand Icon" />
                        </div>
                      </div>
                    </div>
                    {incorrectAmount && (
                      <div className="convert-funds-popup-first-input-error-container">
                        <p className="convert-funds-popup-first-input-error-text">
                          {t("header.insufficientBalance")}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  onClick={() => {
                    let selcetedCurrencyBef = selectedCurrency;
                    let selectedCurrencyToBef = selectedCurrencyTo;
                    setSelectedCurrency(selectedCurrencyToBef);
                    setSelectedCurrencyTo(selcetedCurrencyBef);
                  }}
                  className="convert-funds-popup-input-group-icon"
                >
                  <img src={transferVertical} alt="Currency Toggle" />
                </div>

                <div className="convert-funds-popup-second-input-group">
                  <div className="convert-funds-popup-first-input-group">
                    <p className="convert-funds-popup-first-input-text">
                      {t("convertFunds.to")}
                    </p>
                    <div className="convert-funds-popup-first-input-container">
                      <div
                        style={{ gap: "4px" }}
                        className="a-f-content-footer-input-group"
                      >
                        <p className="a-f-content-footer-input-text">
                          {selectedCurrencyTo.officialCurrencySymbol}
                        </p>
                        <input
                          value={
                            Number(amount) > 0
                              ? `${
                                  extractNumberWithCommas(
                                    Number(
                                      amount * Number(exchangeRate),
                                    )?.toFixed(4),
                                  )?.fmtNumber
                                }`
                              : "00.00"
                          }
                          disabled={true}
                          className="convert-funds-popup-first-input"
                          type="text"
                          placeholder="00.00"
                        />
                      </div>

                      <div
                        onClick={() => {
                          setCurrencyClicked("to");
                          setShowAllCurrencies(true);
                        }}
                        className="convert-funds-popup-first-input-content"
                      >
                        {selectedCurrencyTo?.flag && (
                          <div className="convert-funds-popup-first-input-content-icon">
                            <img
                              src={selectedCurrencyTo.flag}
                              alt="Country Flag"
                            />
                          </div>
                        )}

                        <div className="convert-funds-popup-first-input-content-text-container">
                          <p className="convert-funds-popup-first-input-content-text">
                            {selectedCurrencyTo.currencySymbol}
                          </p>
                          <img src={expandIcon} alt="Expand Icon" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="convert-funds-popup-first-line"></div>

                  <div className="convert-funds-popup-second-input-footer">
                    {/* <div className="convert-funds-popup-second-input-footer-content">
                      <div className="convert-funds-popup-second-input-footer-content-container">
                        <p className="convert-funds-popup-second-input-footer-content-title">
                          Our Conversion Fee:
                        </p>
                        <p className="convert-funds-popup-second-input-footer-content-label">
                          {((0.5 / 100) * Number(amount)).toFixed(4)}{" "}
                          {selectedCurrency.currencySymbol}
                        </p>
                      </div>
                    </div> */}

                    <div className="convert-funds-popup-second-input-footer-content">
                      <div className="convert-funds-popup-second-input-footer-content-container">
                        <p className="convert-funds-popup-second-input-footer-content-title">
                          {t("convertFunds.conversionRate")}
                        </p>
                        <p className="convert-funds-popup-second-input-footer-content-label">
                          1 {selectedCurrency?.currencySymbol} ={" "}
                          {exchangeRate?.toFixed(4)}{" "}
                          {selectedCurrencyTo?.currencySymbol}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showGraph && (
            <div className="convert-funds-popup-graph">
              <img
                style={{ width: "100%", height: "100%" }}
                src={graphImg}
                alt="Graph"
              />
            </div>
          )}

          <div className="convert-funds-popup-body">
            {!showGraph && (
              <div
                onClick={() => {
                  setShowGraph(true);
                }}
                className="convert-funds-popup-body-first"
              >
                <div className="convert-funds-popup-body-first-header">
                  <div className="convert-funds-popup-body-first-header-icon">
                    <img src={graphUp} alt="Graph Icon" />
                  </div>

                  <div className="convert-funds-popup-body-first-header-text-container">
                    <div className="convert-funds-popup-body-first-header-text-main">
                      <p className="convert-funds-popup-body-first-header-text">
                        Graph
                      </p>
                      <p className="convert-funds-popup-body-first-header-label">
                        Information may not be accurate
                      </p>
                    </div>
                  </div>
                </div>

                <img src={expandIcon} alt="Expand Icon" />
              </div>
            )}

            {/* <div className="convert-funds-popup-body-second">
              <div className="convert-funds-popup-body-second-container">
                <div className="convert-funds-popup-body-second-header">
                  <p className="convert-funds-popup-body-second-title">
                    Foresight
                  </p>
                  <p className="convert-funds-popup-body-second-label">
                    Information may not be accurate
                  </p>
                </div>

                <div className="convert-funds-popup-body-second-footer">
                  <div className="convert-funds-popup-body-second-footer-content">
                    <p className="convert-funds-popup-body-second-footer-content-text">
                      Rates usually drop between 1AM to 6PM on Monday
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      )}

      {showAllCurrencies && (
        <div
          style={{ overflow: "auto", marginBottom: "30px" }}
          className="add-funds-content"
        >
          <div className="add-funds-content-header">
            <div className="add-funds-content-header-text-container">
              <img
                onClick={() => {
                  setShowAllCurrencies(false);
                  setNewSearchContent(null);
                }}
                className="add-funds-popup-back-icon"
                alt="Back Icon"
                src={backIcon}
              />
              <p className="add-funds-search-header-text">
                {" "}
                {t("borrow.chooseCurrency")}
              </p>
            </div>
            <img
              onClick={() => {
                props.setShowPopup(false);
                props.setPopupContent(null);
                setNewSearchContent(null);
                props.setPopupContentPosition("center");
                if (props.setFavouriteClicked) {
                  props.setFavouriteClicked(false);
                }
              }}
              className="add-funds-popup-close-icon"
              alt="Close Icon"
              src={popupCloseIcon}
            />
          </div>
          <div className="add-funds-content-search">
            <img alt="Search Icon" src={searchIcon} />
            <input
              onInputCapture={() => {
                selectedCurrency.isClicked = false;
              }}
              onInput={(e) => {
                if (e.target.value === "") {
                  setNewSearchContent(null);
                } else {
                  setNewSearchContent(
                    // eslint-disable-next-line array-callback-return
                    allCurrencies.filter((curr) => {
                      if (
                        curr.currencySymbol
                          .toLowerCase()
                          .includes(e.target.value.toLowerCase())
                      ) {
                        curr.searched = e.target.value.toLowerCase();
                        curr.nameArray = curr.currencySymbol.split("");
                        return curr;
                      }
                    }),
                  );
                }
                const previouslyActiveTag = document.getElementsByClassName(
                  "a-f-content-search-header-main-active",
                );
                if (previouslyActiveTag.length > 0) {
                  previouslyActiveTag[0].className =
                    "a-f-content-search-header-main";
                }
                handleChooseCurrencyButtonDisplay();
              }}
              className="add-funds-content-search-input"
              type="text"
              placeholder={t("placeholder.currencyOrCountrySearch")}
            />
          </div>
          <div className="add-funds-content-search-result">
            <div className="a-f-content-search-result-header">
              {allCurrenciesLoading && <p>{t("common.loading")}...</p>}
              {allCurrencies
                .filter(
                  (curr) =>
                    curr.currencySymbol &&
                    curr.officialCurrencySymbol &&
                    curr.currencyName,
                )
                .map((curr, idx) => (
                  <>
                    {currencyClicked === "from" &&
                      curr?.address !== selectedCurrencyTo?.address && (
                        <div
                          id={`crypto-curencies-${idx}`}
                          key={`crypto-curencies-${idx}`}
                          onClickCapture={() => {
                            curr["isClicked"] = true;
                            setSelectedCurrency(curr);
                          }}
                          onClick={(e) => {
                            const previouslyActiveTag =
                              document.getElementsByClassName(
                                "a-f-content-search-header-main-active",
                              );
                            if (previouslyActiveTag.length > 0) {
                              previouslyActiveTag[0].className =
                                "a-f-content-search-header-main";
                            }
                            const currentTag = document.getElementById(
                              `crypto-curencies-${idx}`,
                            );
                            currentTag.className =
                              "a-f-content-search-header-main-active";
                            handleChooseCurrencyButtonDisplay();
                          }}
                          className="a-f-content-search-header-main"
                        >
                          <div className="a-f-content-search-header-main-container">
                            <div className="a-f-content-search-header-main-content">
                              <div className="a-f-content-search-header-image">
                                <Avatar name={curr.currencySymbol} />
                              </div>
                              <div className="a-f-content-search-header-text-container">
                                <p className="a-f-content-search-header-text-header">
                                  {curr.currencySymbol}
                                </p>
                                <p className="a-f-content-search-header-text-footer">
                                  {curr.currencyName}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    {currencyClicked === "to" &&
                      curr?.address !== selectedCurrency?.address && (
                        <div
                          id={`crypto-curencies-${idx}`}
                          key={`crypto-curencies-${idx}`}
                          onClickCapture={() => {
                            curr["isClicked"] = true;
                            setSelectedCurrencyTo(curr);
                          }}
                          onClick={(e) => {
                            const previouslyActiveTag =
                              document.getElementsByClassName(
                                "a-f-content-search-header-main-active",
                              );
                            if (previouslyActiveTag.length > 0) {
                              previouslyActiveTag[0].className =
                                "a-f-content-search-header-main";
                            }
                            const currentTag = document.getElementById(
                              `crypto-curencies-${idx}`,
                            );
                            currentTag.className =
                              "a-f-content-search-header-main-active";
                            handleChooseCurrencyButtonDisplay();
                          }}
                          className="a-f-content-search-header-main"
                        >
                          <div className="a-f-content-search-header-main-container">
                            <div className="a-f-content-search-header-main-content">
                              <div className="a-f-content-search-header-image">
                                <Avatar name={curr.currencySymbol} />
                              </div>
                              <div className="a-f-content-search-header-text-container">
                                <p className="a-f-content-search-header-text-header">
                                  {curr.currencySymbol}
                                </p>
                                <p className="a-f-content-search-header-text-footer">
                                  {curr.currencyName}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                ))}
            </div>
          </div>
        </div>
      )}
      {showAllCurrencies && (
        <button
          id="convert-currency-popup-button"
          onClick={(e) => {
            if (
              e.target.className.includes("startup-button") &&
              e.target.className !== "startup-button"
            ) {
              e.target.className = "startup-button-click";
              setShowAllCurrencies(false);
              setNewSearchContent(null);
            } else {
              const buttonElement = document.getElementsByClassName(
                "startup-button-active",
              );
              if (buttonElement.length > 0) {
                buttonElement[0].className = "startup-button-click";
                setShowAllCurrencies(false);
                setNewSearchContent(null);
              }
            }
          }}
          className="startup-button"
        >
          <p className="st-button-text">{t("common.proceed")}</p>
        </button>
      )}
      {!showAllCurrencies && !showGraph && Number(amount) <= 0 && (
        <div
          style={{ width: "100%", marginTop: "25px" }}
          className="verify-kyc-buttons"
        >
          <button
            onClick={() => {
              props.setPopupContentPosition("flex-end");
              props.setPopupContent(
                <AddFunds
                  setPopupContent={props.setPopupContent}
                  setShowPopup={props.setShowPopup}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  generalDataProps={props.generalDataProps}
                  addFundsAction="add-funds"
                />,
              );
            }}
            className="verify-kyc-button-back"
          >
            <p className="verify-kyc-button-back-text">
              {t("header.addFunds")}
            </p>
          </button>
          <button className="verify-kyc-button-inactive">
            <p className="verify-kyc-button-text">
              {t("convertFunds.convert")}
            </p>
          </button>
        </div>
      )}
      {!showAllCurrencies && !showGraph && Number(amount) > 0 && (
        <>
          {incorrectAmount && (
            <button
              id="add-funds-popup-button"
              onClick={async (e) => {
                if (
                  e.target.className.includes("startup-button") &&
                  e.target.className !== "startup-button"
                ) {
                  e.target.className = "startup-button-click";
                } else {
                  const buttonElement = document.getElementsByClassName(
                    "startup-button-active",
                  );
                  if (buttonElement.length > 0) {
                    buttonElement[0].className = "startup-button-click";
                  }
                }
              }}
              className="startup-button"
            >
              <p className="add-funds-popup-a-f-button-text">
                {t("convertFunds.convert")}
              </p>
            </button>
          )}
          {!incorrectAmount && (
            <button
              id="add-funds-popup-button"
              onClick={async (e) => {
                if (
                  e.target.className.includes("startup-button") &&
                  e.target.className !== "startup-button"
                ) {
                  e.target.className = "startup-button-click";
                  if (
                    selectedCurrency?.address &&
                    selectedCurrencyTo?.address &&
                    provider?.getSigner &&
                    userAddress
                  ) {
                    const contrWeb3 = new web3.eth.Contract(
                      CASHABI,
                      selectedCurrency?.address,
                    );

                    const contr = new Cash(
                      provider?.getSigner(userAddress),
                      selectedCurrency?.address,
                    );

                    if (contr && userAddress && contrWeb3) {
                      props.setCustomLoading(true);
                      await contrWeb3.methods
                        .approve(
                          userAddress,
                          ethers.utils
                            .parseEther(amount?.toString())
                            ?.toString(),
                        )
                        .send({ from: userAddress })

                        .then(async (res) => {
                          successToast(
                            "Transaction Successful!",
                            "Contract Approved Successfully",
                            `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.transactionHash}`,
                          );
                          await contrWeb3.methods
                            .transferFrom(
                              userAddress,
                              selectedCurrencyTo?.address,

                              ethers.utils
                                .parseEther(amount?.toString())
                                ?.toString(),
                            )
                            .send({ from: userAddress })

                            .then((res) => {
                              props.setCustomLoading(false);
                              successToast(
                                "Transaction Successful!",
                                "Conversion Successful",
                                `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.transactionHash}`,
                              );
                            })
                            .catch((err) => {
                              props.setCustomLoading(false);
                              errorToast(
                                "Oops Something went wrong",
                                "Conversion failed.",
                              );
                              console.error("conversion failed: ", err);
                            });
                        })
                        .catch((err) => {
                          props.setCustomLoading(false);
                          errorToast(
                            "Oops Something went wrong",
                            "Approval failed.",
                          );
                          console.error("approve failed: ", err);
                        });
                    }
                  }
                } else {
                  const buttonElement = document.getElementsByClassName(
                    "startup-button-active",
                  );
                  if (buttonElement.length > 0) {
                    buttonElement[0].className = "startup-button-click";
                    if (
                      selectedCurrency?.address &&
                      selectedCurrencyTo?.address &&
                      provider?.getSigner &&
                      userAddress
                    ) {
                      const contrWeb3 = new web3.eth.Contract(
                        CASHABI,
                        selectedCurrency?.address,
                      );

                      const contr = new Cash(
                        provider?.getSigner(userAddress),
                        selectedCurrency?.address,
                      );

                      if (contr && userAddress && contrWeb3) {
                        props.setCustomLoading(true);
                        await contrWeb3.methods
                          .approve(
                            userAddress,
                            ethers.utils
                              .parseEther(amount?.toString())
                              ?.toString(),
                          )
                          .send({ from: userAddress })

                          .then(async (res) => {
                            successToast(
                              "Transaction Successful!",
                              "Contract Approved Successfully",
                              `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.transactionHash}`,
                            );
                            await contrWeb3.methods
                              .transferFrom(
                                userAddress,
                                selectedCurrencyTo?.address,

                                ethers.utils
                                  .parseEther(amount?.toString())
                                  ?.toString(),
                              )
                              .send({ from: userAddress })

                              .then((res) => {
                                props.setCustomLoading(false);
                                successToast(
                                  "Transaction Successful!",
                                  "Conversion Successful",
                                  `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.transactionHash}`,
                                );
                              })
                              .catch((err) => {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Oops Something went wrong",
                                  "Conversion failed.",
                                );
                                console.error("conversion failed: ", err);
                              });
                          })
                          .catch((err) => {
                            props.setCustomLoading(false);
                            errorToast(
                              "Oops Something went wrong",
                              "Approval failed.",
                            );
                            console.error("approve failed: ", err);
                          });
                      }
                    }
                  }
                }
              }}
              className="startup-button-active"
            >
              <p className="add-funds-popup-a-f-button-text">
                {t("convertFunds.convert")}
              </p>
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ConvertFunds;
